import React from 'react';
import { CellWrapper } from '../../styles';
import { CellProps } from '../../types';

export const Url = ({ val }: CellProps) => (
  <CellWrapper>
    {val}
  </CellWrapper>
);
